import { CircleHelp } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const QuestionIcon = createLucideIcon(CircleHelp);
